<template>
  <DxTabPanel
    :element-attr="tabPanelAttributes"
    :data-source="productionSteps"
    :loop="false"
    :selected-item="currentItem"
    :selected-index="currentStep"
    :animation-enabled="true"
    :swipe-enabled="false"
    :show-nav-buttons="false"
    @selection-changed="tabSelectionChanged($event)"
  >
    <template #item="{ data: step }">
      <div>
        <div v-if="step == 1" class="filter_container" :use-native="true">
          <DxScrollView ref="receptionInputScroll" v-show="step == 1" class="reception-input-scroll" :use-native="true">
            <div class="reception_input_holder" :class="[{ input_holder_error: $v.productionData.production_date.$error }]">
              <div @click="showCalendarSelector">
                <div class="input_label">{{ $t("common.date") }}</div>
                <div class="input_value">
                  <span>{{ productionData.production_date }}</span>
                </div>
              </div>
              <div v-if="is_date_selector_visible">
                <FunctionalCalendar
                  :date-format="getDefaultDateFormat.toLowerCase()"
                  :is-date-range="false"
                  v-model="calendarData"
                  :change-month-function="true"
                  :change-year-function="true"
                  :is-date-picker="true"
                  @choseDay="calendarDayChosen"
                  @input="onDateSelected"
                ></FunctionalCalendar>
              </div>
            </div>
            <div
              class="reception_input_holder"
              @click="showProductSelector()"
              :class="[{ input_holder_error: $v.productionData.products.$error }]"
            >
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info">
                  <div class="input_label">{{ $t("common.product") }}</div>
                  <div v-if="productionData.products.length > 0" class="input_value">
                    {{ getSelectedProduse() }}
                  </div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">{{ $t("stock_mobile.form.select_product") }}</div>
                  <div class="reception_input_second_value">
                    {{
                      productionData.products.length > 0
                        ? productionData.products[0].quantity + " " + productionData.products[0]?.measure_unit?.symbol
                        : ""
                    }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="reception_input_holder" @click="parcelsClick()">
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info" >
                  <div class="input_label">{{ $t("common.parcels") }}</div>
                  <div class="input_value">{{ getParcelNames }}</div>
                  <div class="reception_input_second_value">
                    {{ getSelectedParcelCountForInput }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="reception_input_holder" @click="warehouseClick()">
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info">
                  <div class="input_label">{{ $t("common.warehouse") }}</div>
                  <div class="input_value">{{ getWareHouseNames }}</div>
                  <div class="reception_input_second_value">
                    {{ getSelectedWarehousesCount }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="input-bottom-spacer"></div>
          </DxScrollView>
        </div>
        <div v-show="step == 2" class="reception_step_map">
          <google-map
            ref="googlemap"
            :showMap="step == 2"
            :selection_mode="true"
            :season_uuid="season_uuid_local"
            :initMapInMount="true"
            mapClass="reception_map"
            @showToastMessage="showToastMessage"
            @removeSelectedParcel="removeSelectedParcel"
            @addSelectedParcel="addSelectedParcel"
          ></google-map>
        </div>
        <div v-show="step == 3" class="reception_step_map">
          <WareHouseSelector :selectedWarehouses.sync="selectedWarehouses" @continue="onWarehouseSelectionContinue" />
        </div>
        <div
          class="reception_bottom_sticky"
          v-show="(step == 2 && selectedLayers.length > 0) || (step == 3 && selectedWarehouses.length > 0)"
        >
          <div class="sticky_action_button" @click="continueFromSelection">{{ $t("common.continue") }}</div>
        </div>
        <div class="reception_bottom_sticky_two_line" v-show="step == 1 && showSaveButtons && !saveButtonPressed">
          <div style="display: flex; flex-direction: row; width: 100%">
            <div class="sticky_action_button" style="margin-right: 6px" @click="saveProduction(true, false)">{{ $t("stock_mobile.form.save_and_new_harvest") }}</div>
          </div>
          <div class="sticky_action_button_second" @click="saveProduction(false, false)">{{ $t("common.save") }}</div>
        </div>
        <ProductSelector
          ref="productSelector"
          :showPopup="productSelectorVisibility"
          @hidden="hideProductSelector"
          :selectedProducts="productionData.products"
          :multipleSelection="false"
          :transactionType="transactionTypeTitle"
        >
        </ProductSelector>
        <ProductionSplitPopup ref="productionSplitPopup" />
        <toast-message ref="toastMessage"></toast-message>
      </div>
    </template>
  </DxTabPanel>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxTabPanel from "devextreme-vue/tab-panel";
import { required, helpers } from "vuelidate/src/validators";
import DxTextBox from "devextreme-vue/text-box";
import DxComboWithAdd from "@/components/Mobile/DxComboWithAdd/index.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxSelectBox from "devextreme-vue/select-box";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import DxTextArea from "devextreme-vue/text-area";
import { FunctionalCalendar } from "vue-functional-calendar";
import moment from "moment";
import ProductSelector from "../Product/ProductSelector.vue";
import GoogleMap from "@/components/Map/GoogleMap.vue";
import WareHouseSelector from "../Product/WareHouseSelector.vue";
import ProductionSplitPopup from "./ProductionSplitPopup.vue";
import { TransactionActions, TransactionOptions } from "../transactions.js";

export default {
  name: "Production",
  data() {
    return {
      preselectDate: true,
      calendarData: {},
      productionSteps: [1, 2, 3],
      currentStep: 1,
      currentItem: 2,
      tabPanelAttributes: {
        class: "reception_tabs",
      },
      productionData: {
        products: [],
        production_date: null,
      },
      is_date_selector_visible: false,
      productSelectorVisibility: false,
      saveButtonPressed: false,
      selectedLayers: [],
      season_uuid_local: "",
      currentSeason: {},
      selectedWarehouses: [],
    };
  },
  computed: {
    ...mapGetters({
      seasons: "seasons/seasons",
      getDefaultDateFormat: "settings/getDefaultDateFormat",
    }),
    transactionTypeTitle() {
      return TransactionOptions.find((opt) => opt.code === TransactionActions.Production)?.title || "";
    },
    showSaveButtons() {
      return (
        this.productionData.products.length > 0 &&
        this.selectedLayers.length > 0 &&
        this.productionData.production_date &&
        this.selectedWarehouses.length > 0
      );
    },
    getSelectedParcelSurfaceDecimal() {
      return this.selectedLayers && this.selectedLayers.length > 0
        ? this.selectedLayers
            .map((l) => l.surface)
            .reduce((x, y) => {
              return (parseFloat(x) + parseFloat(y)).toFixed(2);
            })
        : 0;
    },
    getSelectedParcelSurface() {
      return "Ai selectat " + this.getSelectedParcelSurfaceDecimal + " hectare cu ";
    },
    getSelectedParcelCount() {
      return this.$t("stock_mobile.form.parcel_count", { count: this.selectedLayers.length });
    },
    getParcelNames() {
      return this.selectedLayers.map((l) => l.name).join(", ");
    },
    getSelectedParcelCountForInput() {
      return this.$t("stock_mobile.form.selected_parcels_with_surface", {
        count: this.selectedLayers.length,
        surface: this.getSelectedParcelSurfaceDecimal,
      });
    },
    getWareHouseNames() {
      return this.selectedWarehouses.map((w) => w.department?.name ? `${w.name} (${w.department.name})` : w.name).join(", ");
    },
    getSelectedWarehousesCount() {
      return this.$t("stock_mobile.form.warehouse_count", { count: this.selectedWarehouses.length });
    },
  },
  validations() {
    return {
      productionData: {
        production_date: { required },
        products: { required },
      },
      selectedLayers: { required },
      selectedWarehouses: { required },
    };
  },
  components: {
    DxTabPanel,
    DxTextBox,
    DxComboWithAdd,
    DxScrollView,
    DxSelectBox,
    ToastMessage,
    DxTextArea,
    FunctionalCalendar,
    ProductSelector,
    GoogleMap,
    WareHouseSelector,
    ProductionSplitPopup,
  },
  methods: {
    ...mapActions({
      createProduction: "smTransactions/createProductionTransaction",
      createPreDividedProduction: "smTransactions/createPreDividedProductionTransaction",
      getGroupByCode: "settings/getGroupByCode",
      getSeasons: "seasons/getSeasons",
    }),
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.productionSteps.indexOf(this.currentItem);
      this.changeAddButtonVisibility();
    },
    removeSelectedParcel(layer) {
      const index = this.selectedLayers.findIndex((l) => l.uuid === layer.uuid);
      if (index > -1) {
        this.selectedLayers.splice(index, 1);
      }
      this.setTitle();
    },
    addSelectedParcel(layer) {
      layer.surface = Number.parseFloat(layer.surface);
      if (!this.selectedLayers.some((l) => l.uuid === layer.uuid)) {
        this.selectedLayers.push({ ...layer });
      }
      this.setTitle();
    },
    parcelsClick() {
      this.currentStep = 1;
      this.setTitle();
    },
    warehouseClick() {
      this.currentStep = 2;
      this.setTitle();
    },
    showToastMessage(type, message) {
      this.$refs.toastMessage.showToastMessage(type, message);
    },
    goBack() {
      if (this.currentStep > 0) {
        this.currentStep = 0;
        this.setTitle();
      } else {
        this.$emit("goBackParent");
      }
    },
    setTitle() {
      if (this.currentStep == 0) {
        this.$emit("setTitle", this.$t("stock_mobile.form.harvest_product"), true);
      } else if (this.currentStep == 1) {
        this.$emit("setTitle", this.$t("stock_mobile.form.harvest_product"), true, this.getSelectedParcelSurface, this.getSelectedParcelCount);
      } else if (this.currentStep == 2) {
        this.$emit("setTitle", this.$t("stock_mobile.form.warehouses"), true);
      }
    },
    changeAddButtonVisibility() {
      this.$emit("changeAddButtonVisibility", false);
    },
    getSelectedProduse() {
      if (this.productionData.products.length > 0) {
        if (this.productionData.products.length === 1) {
          return this.productionData.products[0].name;
        } else if (this.productionData.products.length > 1) {
          return this.productionData.products[0].name + ", " + this.productionData.products[1].name;
        }
      } else {
        return null;
      }
    },
    /**
     * Compute client-side split rows mirroring backend getProductionRows logic.
     * Groups layers by department_uuid, distributes total product quantity
     * proportionally by surface area. The last group absorbs rounding remainder.
     * @returns {Array} rows - one row per warehouse/department
     */
    computeSplitRows() {
      const product = this.productionData.products[0];
      const totalQty = parseFloat(product.quantity || 0);
      const decimals = this.$store.getters["settings/getQuantityDecimalPlaces"] ?? 4;
      const totalSurface = this.selectedLayers.reduce((sum, l) => sum + parseFloat(l.surface || 0), 0);

      const byDept = {};
      this.selectedLayers.forEach((layer) => {
        const deptUuid = layer.department_uuid;
        if (!byDept[deptUuid]) {
          byDept[deptUuid] = { layers: [], surface: 0 };
        }
        byDept[deptUuid].layers.push(layer);
        byDept[deptUuid].surface += parseFloat(layer.surface || 0);
      });

      const deptUuids = Object.keys(byDept);
      let assigned = 0;

      return deptUuids.map((deptUuid, idx) => {
        const dept = byDept[deptUuid];
        const warehouse = this.selectedWarehouses.find((w) => w.department_uuid === deptUuid);
        let qty;
        if (idx === deptUuids.length - 1) {
          qty = parseFloat((totalQty - assigned).toFixed(decimals));
        } else {
          qty = parseFloat((totalQty * (dept.surface / (totalSurface || 1))).toFixed(decimals));
          assigned += qty;
        }
        return {
          warehouse_uuid: warehouse.uuid,
          warehouse_name: warehouse.name,
          department_uuid: deptUuid,
          department_name: warehouse.department?.name || null,
          quantity: qty,
          layers: dept.layers.map((l) => ({
            parcel_uuid: l.parcel_uuid,
            season_on_parcel_uuid: l.season_on_parcel_uuid,
            surface: l.surface,
            department_uuid: l.department_uuid,
          })),
          parcel_names: dept.layers.map((l) => l.name).join(", "),
          total_surface: parseFloat(dept.surface.toFixed(2)),
        };
      });
    },
    saveProduction(saveAndNew) {
      this.saveButtonPressed = true;

      if (!this.checkParcelDepartmentInWarehouseDepartment()) {
        this.saveButtonPressed = false;
        return;
      }

      this.$v.productionData.$touch();
      if (this.$v.productionData.$invalid) {
        this.$refs.toastMessage.showError(this.createErrormMssages());
        this.saveButtonPressed = false;
        return;
      }

      // Single warehouse: skip popup and save directly via existing endpoint
      if (this.selectedWarehouses.length <= 1) {
        this._doDirectSave(saveAndNew);
        return;
      }

      // Multiple warehouses: compute split, show confirmation popup
      const splitRows = this.computeSplitRows();
      const product = this.productionData.products[0];
      this.$refs.productionSplitPopup
        .open({
          rows: splitRows,
          totalQuantity: parseFloat(product.quantity || 0),
          measureUnitSymbol: product?.measure_unit?.symbol || "",
        })
        .then((confirmedRows) => {
          if (!confirmedRows) {
            // user cancelled
            this.saveButtonPressed = false;
            return;
          }
          this._doPreDividedSave(saveAndNew, confirmedRows);
        });
    },
    _buildCleanProduct(product) {
      const p = { ...product };
      if (p.uuid && p.uuid.startsWith("NEW_")) p.uuid = null;
      delete p.stock_list;
      delete p.updated_by;
      delete p.partner;
      delete p.created_by;
      delete p.product_type;
      delete p.measure_unit;
      delete p.valid_measureunits_for_product;
      return p;
    },
    _doDirectSave(saveAndNew) {
      const productionForSave = {
        products: this.productionData.products.map(this._buildCleanProduct),
        production_date: this.productionData.production_date,
        layers: this.selectedLayers.map((layer) => ({
          department_uuid: layer.department_uuid,
          parcel_uuid: layer.parcel_uuid,
          season_on_parcel_uuid: layer.season_on_parcel_uuid,
          season_uuid: layer.season_uuid,
          surface: layer.surface,
        })),
        warehouses: this.selectedWarehouses.map((warehouse) => ({
          uuid: warehouse.uuid,
          department_uuid: warehouse.department_uuid,
        })),
      };
      this.createProduction(productionForSave)
        .then((response) => {
          this.$refs.toastMessage.showSuccess("Recepția a fost salvată cu succes!");
          if (saveAndNew && response.data.length > 0) {
            this.resetForm();
            this.saveButtonPressed = false;
          } else {
            this.closeTransactions("Recepția a fost salvată cu succes!");
          }
        })
        .catch(() => {
          this.saveButtonPressed = false;
          this.$refs.toastMessage.showError("A apărut o eroare la salvarea recepției. Contactați administratorul de sistem!");
        });
    },
    _doPreDividedSave(saveAndNew, confirmedRows) {
      const product = this._buildCleanProduct(this.productionData.products[0]);
      const payload = {
        production_date: this.productionData.production_date,
        product,
        rows: confirmedRows.map((row) => ({
          warehouse_uuid: row.warehouse_uuid,
          department_uuid: row.department_uuid,
          quantity: row.quantity,
          layers: row.layers,
        })),
      };
      this.createPreDividedProduction(payload)
        .then((response) => {
          this.$refs.toastMessage.showSuccess("Recepția a fost salvată cu succes!");
          if (saveAndNew && response.data.length > 0) {
            this.resetForm();
            this.saveButtonPressed = false;
          } else {
            this.closeTransactions("Recepția a fost salvată cu succes!");
          }
        })
        .catch(() => {
          this.saveButtonPressed = false;
          this.$refs.toastMessage.showError("A apărut o eroare la salvarea recepției. Contactați administratorul de sistem!");
        });
    },
    checkParcelDepartmentInWarehouseDepartment() {
      let has_pair = true;
      if (this.selectedLayers.length > 0) {
        this.selectedLayers.forEach((layer) => {
          let matchingWarehouses = this.selectedWarehouses.filter((warehouse) => {
            return warehouse.department_uuid == layer.department_uuid;
          });
          let matching_count = matchingWarehouses.length ?? 0;
          if (matching_count == 0) {
            has_pair = false;
            this.$refs.toastMessage.showError(this.$t("stock_mobile.form.parcel_no_warehouse", { name: layer.name }));
            return;
          } else if (matching_count > 1) {
            has_pair = false;
            this.$refs.toastMessage.showError(this.$t("stock_mobile.form.parcel_multiple_warehouses", { name: layer.name }));
            return;
          }
        });
      }

      return has_pair;
    },
    createErrormMssages() {
      let errorMessages = [];

      if (this.productionData.products.length == 0) {
        errorMessages.push(this.$t("stock_mobile.form.error_product_required"));
      }

      this.productionData.products.forEach((product, index) => {
        if (!product.measure_unit_id) {
          errorMessages.push(`Unitatea de măsură este obligatorie (${product.name})!`);
        }
        if (!product.product_type_uuid) {
          errorMessages.push(this.$t("stock_mobile.form.error_product_type_required", { name: product.name }));
        }
        if ((product.quantity ?? 0) <= 0) {
          errorMessages.push(`Cantitatea ${product.name} trebuie să fie mai mare de 0!`);
        }
        if (!((product.unit_price ?? -1) >= 0)) {
          errorMessages.push(`Prețul unitar ${product.name} trebuie să fie egal sau mai mare de 0!`);
        }
      });

      if (errorMessages.length > 0) {
        return errorMessages;
      }

      if (this.$v.productionData.production_date.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_date_required"));
      }

      if (this.selectedLayers.length == 0) {
        errorMessages.push("Parcela este obligatoriu!");
      }

      if (this.selectedWarehouses.length == 0) {
        errorMessages.push(this.$t("stock_mobile.form.error_warehouse_required"));
      }

      return errorMessages;
    },
    goForward() {
      this.currentStep = this.currentStep + 1;
      this.setTitle();
    },
    showProductSelector() {
      this.productSelectorVisibility = true;
    },
    hideProductSelector() {
      this.productSelectorVisibility = false;
    },
    resetForm() {
      this.$v.$reset();
      this.productionData = {
        products: [],
        production_date: this.productionData.production_date,
      };
      this.selectedLayers = [];
      this.selectedWarehouses = [];

      this.$refs["receptionInputScroll"].instance.scrollTo(0);

      if (this.$refs.googlemap) {
        this.$refs.googlemap.resetSelection();
        this.$refs.googlemap.refreshLayers();
      }
    },
    closeTransactions(message) {
      this.$emit("closeTransactions", message);
    },
    showCalendarSelector() {
      this.is_date_selector_visible = !this.is_date_selector_visible;
    },
    calendarDayChosen(data) {
      this.is_date_selector_visible = false;
    },
    onDateSelected(date) {
      this.productionData.production_date = date.selectedDate;
    },
    continueFromSelection() {
      this.currentStep = 0;
      this.setTitle();
    },
    setCurrentSeason(seasons) {
      if (seasons.length === 0) return;

      this.currentSeason = seasons[0];
      seasons.forEach((obj) => {
        if (new Date(obj.created_at) > new Date(this.currentSeason.created_at)) {
          this.$set(this, "currentSeason", obj);
        }
      });
      this.season_uuid_local = this.currentSeason.uuid;
    },
    onWarehouseSelectionContinue(selectedWarehouses) {
      if (selectedWarehouses.length > 0) {
        this.selectedWarehouses = selectedWarehouses;
      }
    },
  },
  mounted() {
    this.getGroupByCode({
      code: "STOCK_MANAGEMENT",
    }).then((response) => {
      let _setting = response.items.find((obj) => obj.code == "USE_CURRENT_DATE_ON_CREATION");
      this.preselectDate = _setting?.value == "1";
      if (this.preselectDate) {
        this.productionData.production_date = moment().format(this.getDefaultDateFormat);
      }
    });

    this.getSeasons();
    this.setTitle();
  },
  watch: {
    seasons: {
      handler: function (newVal) {
        this.setCurrentSeason(newVal);
      },
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/reception.scss";
</style>
